import React, { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    checkIn: '',
    checkOut: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Booking inquiry submitted:', formData);
    alert('Thank you for your inquiry! We will contact you shortly.');
    setFormData({
      name: '',
      phone: '',
      email: '',
      checkIn: '',
      checkOut: '',
      message: ''
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section
      id="contact"
      className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-sky-50 via-blue-50 to-cyan-50 text-gray-900 relative overflow-hidden"
    >
      {/* Animated Background Orbs */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 left-20 w-72 h-72 bg-sky-300 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-20 w-72 h-72 bg-cyan-300 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-300 rounded-full blur-3xl opacity-30 animate-pulse" style={{ animationDelay: '2s' }} />
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-sky-500 via-blue-600 to-cyan-500 drop-shadow-lg mb-4 animate-pulse">
            Contact Us
          </h2>
          <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-600">
            Ready to start your dream journey? Get in touch with us today! 
            We're available 24/7 to help plan your perfect vacation.
          </p>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-sky-500 to-cyan-500 mx-auto rounded-full mt-4"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
          {/* Contact Info */}
          <div className="space-y-6 sm:space-y-8">
            <div className="bg-white/70 backdrop-blur-sm border border-sky-200 rounded-2xl p-6 hover:border-sky-400 hover:shadow-xl hover:shadow-sky-300/50 transition-all duration-300">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">
                We Love To Hear From You
              </h3>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-4">
                Travelrmania delivers the greatest service with luxury vehicles 
                and premium travel experiences for your comfort. We provide sanitizers, masks, 
                and complete surface cleaning to keep you safe and healthy.
              </p>
              <p className="text-base text-gray-600 leading-relaxed">
                <span className="font-semibold text-cyan-600">Working Hours:</span> 24/7 Available
              </p>
            </div>

            <div className="space-y-4 sm:space-y-6">
              {[
                { 
                  icon: (
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                  ),
                  label: 'Visit Us', 
                  value: 'New Delhi, India', 
                  color: 'from-sky-500 to-blue-500',
                  link: 'https://maps.google.com/?q=New+Delhi+India'
                },
                { 
                  icon: (
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                  ),
                  label: 'Call Us', 
                  value: '+91-89295-50611', 
                  color: 'from-cyan-500 to-blue-500',
                  link: 'tel:+918929550611'
                },
                { 
                  icon: (
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                  ),
                  label: 'Email Us', 
                  value: 'travelrmania@gmail.com', 
                  color: 'from-sky-500 to-cyan-500',
                  link: 'mailto:travelrmania@gmail.com'
                }
              ].map((contact, i) => (
                <a
                  key={i}
                  href={contact.link}
                  target={contact.label === 'Visit Us' ? '_blank' : '_self'}
                  rel={contact.label === 'Visit Us' ? 'noopener noreferrer' : ''}
                  className="flex items-start gap-4 p-4 bg-white/70 backdrop-blur-sm border border-sky-200 rounded-xl hover:border-sky-400 hover:shadow-lg hover:shadow-sky-300/50 hover:scale-105 transition-all duration-300 cursor-pointer"
                >
                  <div className={`w-12 h-12 rounded-full bg-gradient-to-r ${contact.color} flex items-center justify-center text-white shadow-lg flex-shrink-0`}>
                    {contact.icon}
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{contact.label}</h4>
                    <p className="text-gray-600 text-sm">{contact.value}</p>
                  </div>
                </a>
              ))}
            </div>

            {/* Quick Actions */}
            <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 rounded-xl shadow-lg hover:shadow-green-500/50 hover:scale-105 transition-all duration-300">
              <h4 className="text-lg font-bold mb-3 text-white">Quick Contact</h4>
              <p className="text-sm mb-4 text-white/90">Get instant response on WhatsApp</p>
              <a
                href="https://wa.me/918929550611"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-white text-green-600 font-bold px-6 py-3 rounded-full hover:scale-105 transition-transform duration-200"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Chat on WhatsApp
              </a>
            </div>
          </div>

          {/* Booking Form */}
          <div>
            <div className="bg-white/70 backdrop-blur-sm border border-sky-200 p-6 sm:p-8 rounded-2xl shadow-lg hover:border-sky-400 hover:shadow-xl hover:shadow-sky-300/50 transition-all duration-300">
              <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Get a Free Quote</h3>
                <p className="text-sm text-gray-600">Fill the form and we'll get back to you shortly</p>
              </div>

              <div className="space-y-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Your Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      className="w-full px-4 py-3 bg-white border border-sky-300 text-gray-900 rounded-xl focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent transition-all duration-300 placeholder-gray-400"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Phone Number *
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter phone number"
                      className="w-full px-4 py-3 bg-white border border-sky-300 text-gray-900 rounded-xl focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300 placeholder-gray-400"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    className="w-full px-4 py-3 bg-white border border-sky-300 text-gray-900 rounded-xl focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent transition-all duration-300 placeholder-gray-400"
                  />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Check-in Date *
                    </label>
                    <input
                      type="date"
                      name="checkIn"
                      value={formData.checkIn}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-white border border-sky-300 text-gray-900 rounded-xl focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Check-out Date *
                    </label>
                    <input
                      type="date"
                      name="checkOut"
                      value={formData.checkOut}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-white border border-sky-300 text-gray-900 rounded-xl focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Your Requirements
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={4}
                    placeholder="Tell us about your travel plans, destinations, number of travelers, vehicle preference..."
                    className="w-full px-4 py-3 bg-white border border-sky-300 text-gray-900 rounded-xl focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent transition-all duration-300 resize-none placeholder-gray-400"
                  />
                </div>

                <button
                  onClick={handleSubmit}
                  className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-gradient-to-r from-sky-500 via-blue-500 to-cyan-500 text-white font-bold rounded-xl shadow-lg hover:shadow-2xl hover:shadow-sky-400/50 hover:scale-105 transition-all duration-300"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                  </svg>
                  <span>Submit Inquiry</span>
                </button>

                <p className="text-xs text-center text-cyan-600 font-semibold">
                  🎁 Get 10% off on your first trip with Travelrmania!
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Customer Satisfaction Banner */}
        <div className="mt-12 sm:mt-16 bg-gradient-to-r from-sky-500 via-blue-500 to-cyan-500 p-8 rounded-2xl shadow-xl hover:shadow-2xl hover:shadow-sky-400/50 transition-all duration-300 text-center text-white">
          <h3 className="text-2xl sm:text-3xl font-bold mb-3">Satisfaction Guaranteed</h3>
          <p className="text-base sm:text-lg mb-6 opacity-90">
            Fully Sanitized Cars • Vaccinated Drivers • Professional Service • 24/7 Support
          </p>
          <div className="flex flex-wrap justify-center gap-3 text-sm">
            <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border border-white/30 hover:bg-white/30 transition-all duration-300">✅ Best Price Guarantee</span>
            <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border border-white/30 hover:bg-white/30 transition-all duration-300">🛡️ Safe & Secure</span>
            <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border border-white/30 hover:bg-white/30 transition-all duration-300">📞 24/7 Support</span>
            <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border border-white/30 hover:bg-white/30 transition-all duration-300">⭐ 5.0 Rating</span>
          </div>
        </div>
      </div>
    </section>
  );
}

// import React, { useState } from 'react';

// export default function Contact() {
//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     checkIn: '',
//     checkOut: '',
//     message: ''
//   });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log('Booking inquiry submitted:', formData);
//     alert('Thank you for your inquiry! We will contact you shortly.');
//     setFormData({
//       name: '',
//       phone: '',
//       email: '',
//       checkIn: '',
//       checkOut: '',
//       message: ''
//     });
//   };

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   return (
//     <section
//       id="contact"
//       className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-slate-900 via-blue-950 to-black text-white relative overflow-hidden"
//     >
//       {/* Animated Background Orbs */}
//       <div className="absolute inset-0 opacity-20">
//         <div className="absolute top-20 left-20 w-72 h-72 bg-sky-500 rounded-full blur-3xl animate-pulse" />
//         <div className="absolute bottom-20 right-20 w-72 h-72 bg-amber-500 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
//         <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600 rounded-full blur-3xl opacity-30 animate-pulse" style={{ animationDelay: '2s' }} />
//       </div>

//       <div className="max-w-6xl mx-auto relative z-10">
//         {/* Section Header */}
//         <div className="text-center mb-12 sm:mb-16">
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-sky-400 via-blue-300 to-amber-400 drop-shadow mb-4">
//             Contact Us
//           </h2>
//           <p className="text-base sm:text-lg max-w-2xl mx-auto text-slate-300">
//             Ready to start your dream journey? Get in touch with us today! 
//             We're available 24/7 to help plan your perfect vacation.
//           </p>
//           <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-sky-500 to-amber-500 mx-auto rounded-full mt-4"></div>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
//           {/* Contact Info */}
//           <div className="space-y-6 sm:space-y-8">
//             <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-2xl p-6 hover:border-sky-500 transition-all duration-300">
//               <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4 sm:mb-6">
//                 We Love To Hear From You
//               </h3>
//               <p className="text-base sm:text-lg text-slate-300 leading-relaxed mb-4">
//                 Travelrmania delivers the greatest service with luxury vehicles 
//                 and premium travel experiences for your comfort. We provide sanitizers, masks, 
//                 and complete surface cleaning to keep you safe and healthy.
//               </p>
//               <p className="text-base text-slate-300 leading-relaxed">
//                 <span className="font-semibold text-amber-400">Working Hours:</span> 24/7 Available
//               </p>
//             </div>

//             <div className="space-y-4 sm:space-y-6">
//               {[
//                 { 
//                   icon: (
//                     <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
//                       <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
//                     </svg>
//                   ),
//                   label: 'Visit Us', 
//                   value: 'New Delhi, India', 
//                   color: 'from-sky-500 to-blue-500',
//                   link: 'https://maps.google.com/?q=New+Delhi+India'
//                 },
//                 { 
//                   icon: (
//                     <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
//                       <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
//                     </svg>
//                   ),
//                   label: 'Call Us', 
//                   value: '+91-89295-50611', 
//                   color: 'from-amber-500 to-orange-500',
//                   link: 'tel:+918929550611'
//                 },
//                 { 
//                   icon: (
//                     <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
//                       <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
//                       <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
//                     </svg>
//                   ),
//                   label: 'Email Us', 
//                   value: 'jagdish0000singh@gmail.com', 
//                   color: 'from-sky-500 to-cyan-500',
//                   link: 'mailto:jagdish0000singh@gmail.com'
//                 }
//               ].map((contact, i) => (
//                 <a
//                   key={i}
//                   href={contact.link}
//                   target={contact.label === 'Visit Us' ? '_blank' : '_self'}
//                   rel={contact.label === 'Visit Us' ? 'noopener noreferrer' : ''}
//                   className="flex items-start gap-4 p-4 bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-xl hover:border-sky-500 hover:shadow-lg hover:shadow-sky-500/20 hover:scale-105 transition-all duration-300 cursor-pointer"
//                 >
//                   <div className={`w-12 h-12 rounded-full bg-gradient-to-r ${contact.color} flex items-center justify-center text-white shadow-lg flex-shrink-0`}>
//                     {contact.icon}
//                   </div>
//                   <div>
//                     <h4 className="font-semibold text-white mb-1">{contact.label}</h4>
//                     <p className="text-slate-300 text-sm">{contact.value}</p>
//                   </div>
//                 </a>
//               ))}
//             </div>

//             {/* Quick Actions */}
//             <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 rounded-xl shadow-lg hover:shadow-green-500/50 transition-all duration-300">
//               <h4 className="text-lg font-bold mb-3 text-white">Quick Contact</h4>
//               <p className="text-sm mb-4 text-white/90">Get instant response on WhatsApp</p>
//               <a
//                 href="https://wa.me/918929550611"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="flex items-center justify-center gap-2 bg-white text-green-600 font-bold px-6 py-3 rounded-full hover:scale-105 transition-transform duration-200"
//               >
//                 <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                   <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//                 </svg>
//                 Chat on WhatsApp
//               </a>
//             </div>
//           </div>

//           {/* Booking Form */}
//           <div>
//             <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 p-6 sm:p-8 rounded-2xl shadow-lg hover:border-sky-500 transition-all duration-300">
//               <div className="text-center mb-6">
//                 <h3 className="text-xl font-bold text-white mb-2">Get a Free Quote</h3>
//                 <p className="text-sm text-slate-300">Fill the form and we'll get back to you shortly</p>
//               </div>

//               <div className="space-y-5">
//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-semibold text-slate-300 mb-2">
//                       Your Name *
//                     </label>
//                     <input
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleChange}
//                       placeholder="Enter your name"
//                       className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent transition-all duration-300 placeholder-slate-500"
//                     />
//                   </div>

//                   <div>
//                     <label className="block text-sm font-semibold text-slate-300 mb-2">
//                       Phone Number *
//                     </label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleChange}
//                       placeholder="Enter phone number"
//                       className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-300 placeholder-slate-500"
//                     />
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-slate-300 mb-2">
//                     Email Address *
//                   </label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     placeholder="Enter your email"
//                     className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent transition-all duration-300 placeholder-slate-500"
//                   />
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-semibold text-slate-300 mb-2">
//                       Check-in Date *
//                     </label>
//                     <input
//                       type="date"
//                       name="checkIn"
//                       value={formData.checkIn}
//                       onChange={handleChange}
//                       className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-300"
//                     />
//                   </div>

//                   <div>
//                     <label className="block text-sm font-semibold text-slate-300 mb-2">
//                       Check-out Date *
//                     </label>
//                     <input
//                       type="date"
//                       name="checkOut"
//                       value={formData.checkOut}
//                       onChange={handleChange}
//                       className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-300"
//                     />
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-slate-300 mb-2">
//                     Your Requirements
//                   </label>
//                   <textarea
//                     name="message"
//                     value={formData.message}
//                     onChange={handleChange}
//                     rows={4}
//                     placeholder="Tell us about your travel plans, destinations, number of travelers, vehicle preference..."
//                     className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent transition-all duration-300 resize-none placeholder-slate-500"
//                   />
//                 </div>

//                 <button
//                   onClick={handleSubmit}
//                   className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-gradient-to-r from-sky-500 via-blue-500 to-amber-500 text-white font-bold rounded-xl shadow-lg hover:shadow-2xl hover:shadow-sky-500/50 hover:scale-105 transition-all duration-300"
//                 >
//                   <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
//                   </svg>
//                   <span>Submit Inquiry</span>
//                 </button>

//                 <p className="text-xs text-center text-amber-400 font-semibold">
//                   🎁 Get 10% off on your first trip with Travelrmania!
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Customer Satisfaction Banner */}
//         <div className="mt-12 sm:mt-16 bg-gradient-to-r from-sky-500 via-blue-500 to-amber-500 p-8 rounded-2xl shadow-xl hover:shadow-2xl hover:shadow-sky-500/30 transition-all duration-300 text-center text-white">
//           <h3 className="text-2xl sm:text-3xl font-bold mb-3">Satisfaction Guaranteed</h3>
//           <p className="text-base sm:text-lg mb-6 opacity-90">
//             Fully Sanitized Cars • Vaccinated Drivers • Professional Service • 24/7 Support
//           </p>
//           <div className="flex flex-wrap justify-center gap-3 text-sm">
//             <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border border-white/30 hover:bg-white/30 transition-all duration-300">✅ Best Price Guarantee</span>
//             <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border border-white/30 hover:bg-white/30 transition-all duration-300">🛡️ Safe & Secure</span>
//             <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border border-white/30 hover:bg-white/30 transition-all duration-300">📞 24/7 Support</span>
//             <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border border-white/30 hover:bg-white/30 transition-all duration-300">⭐ 5.0 Rating</span>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// import React, { useState } from 'react';

// export default function Contact() {
//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     checkIn: '',
//     checkOut: '',
//     message: ''
//   });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Handle form submission - you can integrate with your backend or email service
//     console.log('Booking inquiry submitted:', formData);
//     alert('Thank you for your inquiry! We will contact you shortly.');
//     // Reset form
//     setFormData({
//       name: '',
//       phone: '',
//       email: '',
//       checkIn: '',
//       checkOut: '',
//       message: ''
//     });
//   };

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   return (
//     <section
//       id="contact"
//       className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-blue-50 via-white to-purple-100 text-gray-800"
//     >
//       <div className="max-w-6xl mx-auto">
//         {/* Section Header */}
//         <div className="text-center mb-12 sm:mb-16">
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-purple-600 to-pink-500 drop-shadow mb-4">
//             Contact Us
//           </h2>
//           <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-700">
//             Ready to start your dream journey? Get in touch with us today! 
//             We're available 24/7 to help plan your perfect vacation.
//           </p>
//           <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full mt-4"></div>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
//           {/* Contact Info */}
//           <div className="space-y-6 sm:space-y-8">
//             <div>
//               <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6">
//                 We Love To Hear From You
//               </h3>
//               <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-4">
//                 Dream to Travels delivers the greatest service with luxury vehicles 
//                 and tempo travellers for your comfort. We provide sanitizers, masks, 
//                 and complete surface cleaning to keep you safe and healthy.
//               </p>
//               <p className="text-base text-gray-600 leading-relaxed">
//                 <span className="font-semibold text-purple-600">Working Hours:</span> 24/7 Available
//               </p>
//             </div>

//             <div className="space-y-4 sm:space-y-6">
//               {[
//                 { 
//                   icon: '📍', 
//                   label: 'Visit Us', 
//                   value: 'A-851, Camp no.4, Jawala Puri Delhi, India 110087', 
//                   color: 'from-blue-500 to-purple-500',
//                   link: 'https://maps.google.com/?q=A-851,+Camp+no.4,+Jawala+Puri+Delhi+110087'
//                 },
//                 { 
//                   icon: '📞', 
//                   label: 'Call Us', 
//                   value: '+91-7027005176 / +91-7082127844', 
//                   color: 'from-purple-500 to-pink-500',
//                   link: 'tel:+917027005176'
//                 },
//                 { 
//                   icon: '✉️', 
//                   label: 'Email Us', 
//                   value: 'Dreamtotravels24@gmail.com', 
//                   color: 'from-pink-500 to-red-500',
//                   link: 'mailto:Dreamtotravels24@gmail.com'
//                 }
//               ].map((contact, i) => (
//                 <a
//                   key={i}
//                   href={contact.link}
//                   target={contact.label === 'Visit Us' ? '_blank' : '_self'}
//                   rel={contact.label === 'Visit Us' ? 'noopener noreferrer' : ''}
//                   className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-md border border-gray-100 hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
//                 >
//                   <div className={`w-12 h-12 rounded-full bg-gradient-to-r ${contact.color} flex items-center justify-center text-white shadow-lg text-2xl flex-shrink-0`}>
//                     {contact.icon}
//                   </div>
//                   <div>
//                     <h4 className="font-semibold text-gray-800 mb-1">{contact.label}</h4>
//                     <p className="text-gray-600 text-sm">{contact.value}</p>
//                   </div>
//                 </a>
//               ))}
//             </div>

//             {/* Quick Actions */}
//             <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 rounded-xl shadow-lg text-white">
//               <h4 className="text-lg font-bold mb-3">Quick Contact</h4>
//               <p className="text-sm mb-4 opacity-90">Get instant response on WhatsApp</p>
//               <a
//                 href="https://wa.me/917027005176"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="flex items-center justify-center gap-2 bg-white text-green-600 font-bold px-6 py-3 rounded-full hover:scale-105 transition-transform duration-200"
//               >
//                 <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                   <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//                 </svg>
//                 Chat on WhatsApp
//               </a>
//             </div>
//           </div>

//           {/* Booking Form */}
//           <div>
//             <div
//               className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg border border-gray-100 space-y-6"
//             >
//               <div className="text-center mb-4">
//                 <h3 className="text-xl font-bold text-gray-800">Get a Free Quote</h3>
//                 <p className="text-sm text-gray-600">Fill the form and we'll get back to you shortly</p>
//               </div>

//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">
//                     Your Name *
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     placeholder="Enter your name"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent transition-all duration-300"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">
//                     Phone Number *
//                   </label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     placeholder="Enter phone number"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent transition-all duration-300"
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">
//                   Email Address *
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   placeholder="Enter your email"
//                   className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent transition-all duration-300"
//                 />
//               </div>

//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">
//                     Check-in Date *
//                   </label>
//                   <input
//                     type="date"
//                     name="checkIn"
//                     value={formData.checkIn}
//                     onChange={handleChange}
//                     className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent transition-all duration-300"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">
//                     Check-out Date *
//                   </label>
//                   <input
//                     type="date"
//                     name="checkOut"
//                     value={formData.checkOut}
//                     onChange={handleChange}
//                     className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent transition-all duration-300"
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">
//                   Your Requirements
//                 </label>
//                 <textarea
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   rows={4}
//                   placeholder="Tell us about your travel plans, destinations, number of travelers, vehicle preference..."
//                   className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent transition-all duration-300 resize-none"
//                 />
//               </div>

//               <button
//                 onClick={handleSubmit}
//                 className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white font-bold rounded-xl shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-300"
//               >
//                 <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
//                 </svg>
//                 <span>Submit Inquiry</span>
//               </button>

//               <p className="text-xs text-center text-gray-500">
//                 🎁 Get 15% off on your first trip with Dream to Travels!
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Customer Satisfaction Banner */}
//         <div className="mt-12 sm:mt-16 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 p-8 rounded-2xl shadow-xl text-center text-white">
//           <h3 className="text-2xl sm:text-3xl font-bold mb-3">Satisfaction Guaranteed</h3>
//           <p className="text-base sm:text-lg mb-6 opacity-90">
//             Complimentary WiFi • Fully Sanitized Cars • Vaccinated Drivers • 15% Discount on Food & Drinks
//           </p>
//           <div className="flex flex-wrap justify-center gap-4 text-sm">
//             <span className="bg-white/20 px-4 py-2 rounded-full">✅ Best Price Guarantee</span>
//             <span className="bg-white/20 px-4 py-2 rounded-full">🛡️ Safe & Secure</span>
//             <span className="bg-white/20 px-4 py-2 rounded-full">📞 24/7 Support</span>
//             <span className="bg-white/20 px-4 py-2 rounded-full">⭐ 5.0 Rating</span>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';

// export default function Contact() {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     subject: '',
//     message: ''
//   });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Handle form submission
//     console.log('Form submitted:', formData);
//   };

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   return (
//     <section
//       id="contact"
//       className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-blue-50 via-white to-purple-100 text-gray-800"
//     >
//       <div className="max-w-6xl mx-auto">
//         {/* Section Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           viewport={{ once: true }}
//           className="text-center mb-12 sm:mb-16"
//         >
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-purple-600 to-pink-500 drop-shadow mb-4">
//             Get In Touch
//           </h2>
//           <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-700">
//             Have a project in mind or want to collaborate? I'd love to hear from you! 
//             Let's create something amazing together.
//           </p>
//           <motion.div
//             initial={{ scaleX: 0 }}
//             whileInView={{ scaleX: 1 }}
//             transition={{ delay: 0.3, duration: 0.8 }}
//             className="w-20 sm:w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full mt-4"
//           />
//         </motion.div>

//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
//           {/* Contact Info */}
//           <motion.div
//             initial={{ opacity: 0, x: -50, rotateY: -15 }}
//             whileInView={{ opacity: 1, x: 0, rotateY: 0 }}
//             transition={{ duration: 0.8, type: "spring", stiffness: 80 }}
//             viewport={{ once: true }}
//             className="space-y-6 sm:space-y-8"
//             style={{ transformStyle: 'preserve-3d' }}
//           >
//             <div>
//               <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6">
//                 Let's Start a Conversation
//               </h3>
//               <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
//                 I'm always excited to work on new projects and collaborate with 
//                 passionate people. Whether you have a question, project idea, or 
//                 just want to say hello, feel free to reach out!
//               </p>
//             </div>

//             <div className="space-y-4 sm:space-y-6">
//               {[
//                 { icon: FaEnvelope, label: 'Email', value: 'jagdish0000singh@gmail.com', color: 'from-blue-500 to-purple-500' },
//                 { icon: FaPhone, label: 'Phone', value: '+91 9755856913', color: 'from-purple-500 to-pink-500' },
//                 { icon: FaMapMarkerAlt, label: 'Location', value: 'India', color: 'from-pink-500 to-red-500' }
//               ].map((contact, i) => (
//                 <motion.div
//                   key={i}
//                   initial={{ opacity: 0, x: -30 }}
//                   whileInView={{ opacity: 1, x: 0 }}
//                   transition={{ delay: i * 0.2, duration: 0.6 }}
//                   whileHover={{ 
//                     x: 10, 
//                     scale: 1.02,
//                     boxShadow: "0 10px 25px rgba(0,0,0,0.1)"
//                   }}
//                   className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-md border border-gray-100 transform transition-all duration-300"
//                 >
//                   <motion.div
//                     className={`w-12 h-12 rounded-full bg-gradient-to-r ${contact.color} flex items-center justify-center text-white shadow-lg`}
//                     whileHover={{ rotateY: 180, scale: 1.1 }}
//                     transition={{ duration: 0.6 }}
//                   >
//                     <contact.icon className="text-lg" />
//                   </motion.div>
//                   <div>
//                     <h4 className="font-semibold text-gray-800">{contact.label}</h4>
//                     <p className="text-gray-600">{contact.value}</p>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           </motion.div>

//           {/* Contact Form */}
//           <motion.div
//             initial={{ opacity: 0, x: 50, rotateY: 15 }}
//             whileInView={{ opacity: 1, x: 0, rotateY: 0 }}
//             transition={{ duration: 0.8, type: "spring", stiffness: 80 }}
//             viewport={{ once: true }}
//             style={{ transformStyle: 'preserve-3d' }}
//           >
//             <motion.form
//               onSubmit={handleSubmit}
//               className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg border border-gray-100 space-y-6 transform transition-all duration-300"
//               whileHover={{ 
//                 boxShadow: "0 25px 50px rgba(0,0,0,0.1)",
//                 y: -5
//               }}
//             >
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
//                 <motion.div
//                   whileHover={{ scale: 1.02 }}
//                   transition={{ type: "spring", stiffness: 300 }}
//                 >
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">
//                     Your Name
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required
//                     placeholder="Enter your name"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-300"
//                   />
//                 </motion.div>

//                 <motion.div
//                   whileHover={{ scale: 1.02 }}
//                   transition={{ type: "spring", stiffness: 300 }}
//                 >
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">
//                     Email Address
//                   </label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                     placeholder="Enter your email"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-300"
//                   />
//                 </motion.div>
//               </div>

//               <motion.div
//                 whileHover={{ scale: 1.02 }}
//                 transition={{ type: "spring", stiffness: 300 }}
//               >
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">
//                   Subject
//                 </label>
//                 <input
//                   type="text"
//                   name="subject"
//                   value={formData.subject}
//                   onChange={handleChange}
//                   required
//                   placeholder="What's this about?"
//                   className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-300"
//                 />
//               </motion.div>

//               <motion.div
//                 whileHover={{ scale: 1.02 }}
//                 transition={{ type: "spring", stiffness: 300 }}
//               >
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">
//                   Message
//                 </label>
//                 <textarea
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   required
//                   rows="5"
//                   placeholder="Tell me about your project..."
//                   className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-300 resize-none"
//                 />
//               </motion.div>

//               <motion.button
//                 type="submit"
//                 className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white font-bold rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
//                 whileHover={{ 
//                   scale: 1.02, 
//                   rotateX: 5,
//                   boxShadow: "0 20px 40px rgba(0,0,0,0.2)"
//                 }}
//                 whileTap={{ scale: 0.98 }}
//                 style={{ transformStyle: 'preserve-3d' }}
//               >
//                 <FaPaperPlane className="text-lg" />
//                 <span>Send Message</span>
//               </motion.button>
//             </motion.form>
//           </motion.div>
//         </div>
//       </div>
//     </section>
//   );
// }


// import React from 'react';
// import { motion } from 'framer-motion';

// export default function Contact() {
//   return (
//     <section
//       id="contact"
//       className="py-20 px-6 md:px-16 bg-gradient-to-br from-blue-50 via-white to-purple-100 text-gray-800"
//     >
//       <div className="max-w-4xl mx-auto">
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           viewport={{ once: true }}
//           className="text-center mb-12"
//         >
//           <h2 className="text-4xl sm:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-purple-600 to-pink-500 drop-shadow">
//             Contact Me
//           </h2>
//           <p className="mt-4 text-lg max-w-2xl mx-auto text-gray-700">
//             Interested in working together or have a question? Let’s connect! Fill out the form below and I’ll get back to you within 24 hours.
//           </p>
//         </motion.div>

//         <motion.form
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           viewport={{ once: true }}
//           className="space-y-6 bg-white p-8 rounded-2xl shadow-md"
//         >
//           <div>
//             <label className="block mb-2 font-semibold text-gray-700">Your Name</label>
//             <input
//               type="text"
//               required
//               placeholder="Enter your full name"
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
//             />
//           </div>

//           <div>
//             <label className="block mb-2 font-semibold text-gray-700">Your Email</label>
//             <input
//               type="email"
//               required
//               placeholder="Enter your email address"
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400"
//             />
//           </div>

//           <div>
//             <label className="block mb-2 font-semibold text-gray-700">Your Message</label>
//             <textarea
//               rows="5"
//               required
//               placeholder="Tell me more about your project or inquiry..."
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pink-400"
//             ></textarea>
//           </div>

//           <div className="text-right">
//             <button
//               type="submit"
//               className="bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold px-6 py-3 rounded-lg hover:from-blue-700 hover:to-purple-700 transition duration-300"
//             >
//               Send Message
//             </button>
//           </div>
//         </motion.form>
//       </div>
//     </section>
//   );
// }


// export default function Contact() {
//   return (
//     <section id="contact" className="py-16 px-6 bg-blue-50">
//       <h2 className="text-3xl font-bold mb-4">Contact</h2>
//       <form className="space-y-4 max-w-lg">
//         <input type="text" placeholder="Your Name" className="w-full px-4 py-2 border rounded" />
//         <input type="email" placeholder="Your Email" className="w-full px-4 py-2 border rounded" />
//         <textarea placeholder="Your Message" rows="5" className="w-full px-4 py-2 border rounded"></textarea>
//         <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700">Send Message</button>
//       </form>
//     </section>
//   );
// }
